import React, { useState } from 'react';
import './careerapply.css';
import { useLocation } from 'react-router-dom';
import { db, storage } from '../OurCourses/firebase'; // Import your Firebase configuration
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

function CareerApply() {
  const jobId = new URLSearchParams(useLocation().search).get('id');
  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', phone: '',
    address: '', city: '', position: `Data Entry Operator | Accounting Assistant`,
    experience: '', education: '', skills: '',
    resume: null, salaryExpectation: '',
    availability: 'Immediately', reference: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);

const handleChange = ({ target: { name, value, files } }) => {
  if (name === 'resume') {
    setFormData(prev => ({ ...prev, [name]: files ? files[0] : null }));
  } else {
    setFormData(prev => ({ ...prev, [name]: value }));
  }
};
  const uploadFile = async (file) => {
    if (!file) return null;
    const fileRef = ref(storage, `eccareer/resumes/${uuidv4()}-${file.name}`);
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Upload resume file if exists
      const resumeUrl = await uploadFile(formData.resume);

      // Prepare application data for Firestore
      const applicationData = {
        ...formData,
        resumeUrl: resumeUrl || '',
        jobId: jobId || 'N/A',
        appliedAt: new Date().toISOString(),
        status: 'pending'
      };

      // Remove the file object before saving to Firestore
      delete applicationData.resume;

      // Save to Firestore
      const docRef = await addDoc(collection(db, 'careerApplications'), applicationData);
      console.log('Document written with ID: ', docRef.id);
      
      setSubmitted(true);
    } catch (err) {
      console.error('Error submitting application:', err);
      setError('Failed to submit application. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const Input = ({ label, ...props }) => (
    <div className="form-group">
      <label htmlFor={props.name}>{label}</label>
      <input {...props} onChange={handleChange} value={formData[props.name]} />
    </div>
  );

  const Select = ({ label, name, options, required }) => (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <select name={name} value={formData[name]} onChange={handleChange} required={required}>
        <option value="">Select</option>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );

  const FileInput = ({ label, name, required }) => (
    <div className="form-group">
      <label>{label}</label>
      <div className="file-upload">
        <input 
          type="file" 
          name={name} 
          onChange={handleChange} 
          required={required} 
          accept=".pdf,.doc,.docx" 
          id={name}
        />
        <label htmlFor={name} className="file-upload-label">
          {formData[name]?.name || 'Choose File'}
        </label>
      </div>
    </div>
  );

  if (submitted) {
    return (
      <div className="application-success">
        <div className="success-container">
          <svg className="success-icon" viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
          </svg>
          <h2>Application Submitted Successfully!</h2>
          <p>Thank you for applying to the {formData.position} position.</p>
          <p>We'll review your application and contact you if you're selected for an interview.</p>
          <button className="return-button" onClick={() => {
            setSubmitted(false);
            setStep(1);
            setFormData({
              firstName: '', lastName: '', email: '', phone: '',
              address: '', city: '', title: ``,
              experience: '', education: '', skills: '',
              resume: null, salaryExpectation: '',
              availability: 'Immediately', reference: ''
            });
          }}>
            Submit Another Application
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="career-apply-container">
      <div className="apply-header">
        <h1>Application: <span>{formData.title}</span></h1>
        <div className="progress-bar">
          {[1, 2, 3].map(n => (
            <div key={n} className={`progress-step ${step >= n ? 'active' : ''}`}>{n}</div>
          ))}
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit} className="application-form">
        {step === 1 && (
          <div className="form-step">
            <h2>Personal Information</h2>
            <div className="form-grid">
              <Input label="First Name*" name="firstName" required />
              <Input label="Last Name*" name="lastName" required />
              <Input label="Email Address*" name="email" type="email" required />
              <Input label="Phone Number*" name="phone" type="tel" required />
              <Input label="Address" name="address" />

           
            </div>
            <div className="form-navigation">
              <button type="button" className="next-button" onClick={() => setStep(2)}>
                Next: Professional Info
              </button>
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="form-step">
            <h2>Professional Information</h2>
            <div className="form-grid">
              <Input label="Experience (Years)*" name="experience" type="number" required />
              <Select 
                label="Education*" 
                name="education" 
                required 
                options={['Certificate Course', 'Diploma', 'Higher Diploma', 'Bachelor\'s Degree', 'Master\'s Degree', 'Other']} 
              />
              <div className="form-group span-2">
                <label htmlFor="skills">Key Skills*</label>
                <textarea 
                  id="skills" 
                  name="skills" 
                  value={formData.skills} 
                  onChange={handleChange} 
                  required 
                  placeholder="e.g., Accounting, Data Entry" 
                />
              </div>
              <Select 
                label="Availability*" 
                name="availability" 
                required 
                options={['Immediately', '1-2 weeks', '1 month', 'Other']} 
              />
            </div>
            <div className="form-navigation">
              <button type="button" className="back-button" onClick={() => setStep(1)}>
                Back
              </button>
              <button type="button" className="next-button" onClick={() => setStep(3)}>
                Next: Documents
              </button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="form-step">
            <h2>Documents & Final Details</h2>
            <div className="form-grid">
              <FileInput label="Upload Resume/CV*" name="resume" />
              <Select 
                label="How did you hear about us?" 
                name="reference" 
                options={['Company Website', 'Job Portal', 'Social Media', 'Friend/Colleague', 'Other']} 
              />
            </div>
            <div className="form-navigation">
              <button type="button" className="back-button" onClick={() => setStep(2)}>
                Back
              </button>
              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Application'}
              </button>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

export default CareerApply;